export default __webpack_public_path__ + "img/materials-setup.a367afa1.png";